import { getNearestUpperMultiple, keepValueInRange } from '@cian/utils';

export function getInitialBet(bet: number, maxBet: number, validateStep: boolean, step: number = 1) {
  const newBet = validateStep ? getNearestUpperMultiple(bet + 1, step) || 0 : bet + 1;

  return keepValueInRange(newBet, 0, maxBet);
}
